import { i18n } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { App } from "./app";
import { QueryProviderWrapper } from "./components/query";
import "./sentry";

const storedLanguage = localStorage.getItem("language");
if (storedLanguage) i18n.changeLanguage(storedLanguage);

/**
 * A data router with the whole app under one splat route. The routes themselves stay where they
 * are, as descendant `<Routes>` inside the app; what the data router adds is navigation blocking,
 * which a form with unsaved changes uses to ask before the page goes.
 */
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

function start() {
	/**
	 *  Create the root element and render the application.
	 */
	const root = document.getElementById("root");

	if (root) {
		createRoot(root, {
			onCaughtError: Sentry.reactErrorHandler(),
			onRecoverableError: Sentry.reactErrorHandler(),
			onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
				toast.error("An unexpected error occurred. Please try again later.");
				console.info("Uncaught error", error, errorInfo.componentStack);
			}),
		}).render(
			<QueryProviderWrapper>
				<RouterProvider router={router} />
			</QueryProviderWrapper>,
		);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", start);
} else {
	start();
}
